<template>
  <v-carousel hide-delimiters class="py-2" height="230px">
    <template v-slot:prev="{ on, attrs }" class="mx-0">
      <v-btn
        v-show="produtos.length > columns"
        color="black"
        class="white"
        v-bind="attrs"
        icon
        small
        v-on="on"
        ><v-icon >mdi-chevron-left</v-icon></v-btn
      >
    </template>
    <template v-slot:next="{ on, attrs }">
      <v-btn
        v-show="produtos.length > columns"
        color="black"
        class="white"
        v-bind="attrs"
        icon
        small
        v-on="on"
        ><v-icon>mdi-chevron-right</v-icon></v-btn
      >
    </template>
    <template v-for="(p, index) in produtos">
      <v-carousel-item
        v-if="(index + 1) % columns === 1 || columns === 1"
        :key="index"
      >
        <v-row class="pl-3">
          <template v-for="(n, i) in columns">
            <template v-if="+index + i < produtos.length">
              <v-col :key="i" class="py-4 px-0">
                <router-link
                  :to="
                    '/'+ getTipo(produtos[+index +i].dsSegmento)  +'/' +
                      produtos[+index + i].idGarrafa +
                      '/' +
                      slug(produtos[+index + i].dsGarrafa)
                  "
                >
                  <v-card
                    class="d-flex flex-column align-start pa-2"
                    height="210"
                    max-width="275"
                    style="width: 44vw;"
                  >
                    <div class="text-center" style="width:100%">
                      <img
                        @error="changeImg($event)"
                        :src="
                          $drink_img_uri +
                           getPathImg(produtos[+index +i].dsSegmento) +'/' +
                            produtos[+index + i].idGarrafa +
                            '.png'
                        "
                        style="height: 130px; object-fit: cover;"
                      />
                    </div>
                    <div class="pl-1">
                      <span class="tag tagDest">
                        {{produtos[+index + i].dsSegmento}}
                      </span>
                      <p class="name pt-1">
                        {{ produtos[+index + i].dsGarrafa }}
                      </p>
                    </div>
                  </v-card>
                </router-link>
              </v-col>
            </template>
          </template>
        </v-row>
      </v-carousel-item>
    </template>
  </v-carousel>
</template>
<script>
import "../css/home.css";

export default {
  name: "CarrouselGarrafas",
  props: { dsSegmento: String, produtos: Array },
  data: () => ({}),
  methods: {
    changeImg(e) {
      e.target.src = require("../img/garrafa.png");
    },
    slug(strTitulo) {
      var slug = this.sanitizeTitle(strTitulo);
      return slug;
    },
    getTipo(dsSegmento) { 
      return dsSegmento === "RTD" ? 'bebida': 'produto'
    },
    getPathImg(dsSegmento) { 
      return dsSegmento === "RTD" ? 'bebida' : 'garrafa'
    },
     sanitizeTitle: function(title) {
      var slug = "";
      // Change to lower case
      var titleLower = title.toLowerCase();
      // Letter "e"
      slug = titleLower.replace(/e|é|è|ẽ|ẻ|ẹ|ê|ế|ề|ễ|ể|ệ/gi, "e");
      // Letter "a"
      slug = slug.replace(/a|á|à|ã|ả|ạ|ă|ắ|ằ|ẵ|ẳ|ặ|â|ấ|ầ|ẫ|ẩ|ậ/gi, "a");
      // Letter "o"
      slug = slug.replace(/o|ó|ò|õ|ỏ|ọ|ô|ố|ồ|ỗ|ổ|ộ|ơ|ớ|ờ|ỡ|ở|ợ/gi, "o");
      // Letter "u"
      slug = slug.replace(/u|ú|ù|ũ|ủ|ụ|ư|ứ|ừ|ữ|ử|ự/gi, "u");
      // Letter "d"
      slug = slug.replace(/đ/gi, "d");
      // Trim the last whitespace
      slug = slug.replace(/\s*$/g, "");
      // Change whitespace to "-"
      slug = slug.replace(/\s+/g, "-");

      return slug;
    },
  },
  computed: {
    columns() {
      switch (this.$vuetify.breakpoint.name) {
        case "xs":
          return 2;
        case "sm":
          return 3;
        case "md":
          return 4;
        case "lg":
          return 4;
        case "xl":
          return 4;
        default:
          return 1;
      }
    },
  },
};
</script>
